import * as React from 'react'
import Collapse from 'src/packages/collapse/Collapse'
import Panel from 'src/packages/collapse/Panel'
import Code from 'src/components/Code'
import CodeBox from 'src/components/CodeBox'
import Space from 'src/components/Space'
import { renderString } from 'src/utils/renderCode'

class CollapseExample extends React.Component {
  public static displayName = 'CollapseExample'

  public render() {
    return (
      <div className="collapse-example">
        <section>
          <h1>Collapse 折叠面板</h1>
          <p className="text">可以折叠/展开的内容区域。</p>
        </section>
        <section>
          <h2>何时使用</h2>
          <p className="text">
            对复杂区域进行分组和隐藏时。
            手风琴是一种特殊的折叠面板，只允许单个面板展开。
          </p>
        </section>
        <section>
          <h2>代码示例</h2>
        </section>
        <div className="example">
          <div className="container" style={{ display: 'block' }}>
            <Collapse
              onChange={(key: any) => console.log(key)}
              defaultActiveKey={['1']}
            >
              <Panel
                header={
                  <div
                    style={{
                      height: '30px',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}
                  >
                    Header1
                  </div>
                }
                key="1"
              >
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    paddingLeft: '20px'
                  }}
                >
                  Content of Panel 1
                </div>
              </Panel>
              <Panel
                header={
                  <div
                    style={{
                      height: '30px',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}
                  >
                    Header2
                  </div>
                }
                key="2"
              >
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    paddingLeft: '20px'
                  }}
                >
                  Content of Panel 2
                </div>
              </Panel>
              <Panel
                header={
                  <div
                    style={{
                      height: '30px',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}
                  >
                    Header3
                  </div>
                }
                key="3"
              >
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    paddingLeft: '20px'
                  }}
                >
                  Content of Panel 3
                </div>
              </Panel>
            </Collapse>
          </div>
          <CodeBox title="折叠面板" description="可同时展开多个面板。">
            {renderString(`import { Collapse } from 'components/Collapse'`)}
            {renderString(`import { Panel } from 'components/Collapse'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code
              code={`&lt;Collapse onChange={(activeKey) => this.handleChange(activeKey)}&gt;`}
            />
            <Space count={4} />
            <Code code={`&lt;Panel header="Header1" key="1"&gt;`} />
            <Space count={8} />
            <span className="label">&lt;</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <span className="htmlstr">Content of Panel 1</span>
            <span className="label">&lt;</span>
            <span className="label">/</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <br />
            <Space count={4} /> <Code code={`&lt;/Panel&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Panel header="Header2" key="2"&gt;`} />
            <Space count={8} /> <span className="label">&lt;</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <span className="htmlstr">Content of Panel 2</span>
            <span className="label">&lt;</span>
            <span className="label">/</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <br />
            <Space count={4} /> <Code code={`&lt;/Panel&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Panel header="Header3" key="3"&gt;`} />
            <Space count={8} />
            <span className="label">&lt;</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <span className="htmlstr">Content of Panel 3</span>
            <span className="label">&lt;</span>
            <span className="label">/</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <br />
            <Space count={4} />
            <Code code={`&lt;/Panel&gt;`} />
            <Code code={`&lt;/Collapse&gt;`} />
          </CodeBox>
        </div>
        <div className="example">
          <div className="container" style={{ display: 'block' }}>
            <Collapse onChange={(key: any) => console.log(key)}>
              <Panel
                header={
                  <div
                    style={{
                      height: '30px',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}
                  >
                    Header1
                  </div>
                }
                key="1"
              >
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    paddingLeft: '20px'
                  }}
                >
                  Content of Panel 1
                </div>
              </Panel>
              <Panel
                header={
                  <div
                    style={{
                      height: '30px',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}
                  >
                    Header2
                  </div>
                }
                disabled={true}
                key="2"
              >
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    paddingLeft: '20px'
                  }}
                >
                  Content of Panel 2
                </div>
              </Panel>
              <Panel
                header={
                  <div
                    style={{
                      height: '30px',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}
                  >
                    Header3
                  </div>
                }
                key="3"
              >
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    paddingLeft: '20px'
                  }}
                >
                  Content of Panel 3
                </div>
              </Panel>
            </Collapse>
          </div>
          <CodeBox title="禁用" description="禁用某个面板。">
            {renderString(`import { Collapse } from 'components/Collapse'`)}
            {renderString(`import { Panel } from 'components/Collapse'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code
              code={`&lt;Collapse onChange={(activeKey) => this.handleChange(activeKey)}&gt;`}
            />
            <Space count={4} />
            <Code code={`&lt;Panel header="Header1" key="1"&gt;`} />
            <Space count={8} />
            <span className="label">&lt;</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <span className="htmlstr">Content of Panel 1</span>
            <span className="label">&lt;</span>
            <span className="label">/</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <br />
            <Space count={4} /> <Code code={`&lt;/Panel&gt;`} />
            <Space count={4} />
            <Code
              code={`&lt;Panel header="Header2" key="2" disabled={true}&gt;`}
            />
            <Space count={8} /> <span className="label">&lt;</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <span className="htmlstr">Content of Panel 2</span>
            <span className="label">&lt;</span>
            <span className="label">/</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <br />
            <Space count={4} /> <Code code={`&lt;/Panel&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Panel header="Header3" key="3"&gt;`} />
            <Space count={8} />
            <span className="label">&lt;</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <span className="htmlstr">Content of Panel 3</span>
            <span className="label">&lt;</span>
            <span className="label">/</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <br />
            <Space count={4} />
            <Code code={`&lt;/Panel&gt;`} />
            <Code code={`&lt;/Collapse&gt;`} />
          </CodeBox>
        </div>
        <div className="example">
          <div className="container" style={{ display: 'block' }}>
            <Collapse
              accordion={true}
              onChange={(key: any) => console.log(key)}
              defaultActiveKey={['1']}
            >
              <Panel
                header={
                  <div
                    style={{
                      height: '30px',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}
                  >
                    Header1
                  </div>
                }
                key="1"
              >
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    paddingLeft: '20px'
                  }}
                >
                  Content of Panel 1
                </div>
              </Panel>
              <Panel
                header={
                  <div
                    style={{
                      height: '30px',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}
                  >
                    Header2
                  </div>
                }
                key="2"
              >
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    paddingLeft: '20px'
                  }}
                >
                  Content of Panel 2
                </div>
              </Panel>
              <Panel
                header={
                  <div
                    style={{
                      height: '30px',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}
                  >
                    Header3
                  </div>
                }
                key="3"
              >
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    paddingLeft: '20px'
                  }}
                >
                  Content of Panel 3
                </div>
              </Panel>
            </Collapse>
          </div>
          <CodeBox title="手风琴" description="每次只展开一个面板。">
            {renderString(`import { Collapse } from 'components/Collapse'`)}
            {renderString(`import { Panel } from 'components/Collapse'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code
              code={`&lt;Collapse accordion={true} onChange={(activeKey) => this.handleChange(activeKey)}&gt;`}
            />
            <Space count={4} />
            <Code code={`&lt;Panel header="Header1" key="1"&gt;`} />
            <Space count={8} />
            <span className="label">&lt;</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <span className="htmlstr">Content of Panel 1</span>
            <span className="label">&lt;</span>
            <span className="label">/</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <br />
            <Space count={4} /> <Code code={`&lt;/Panel&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Panel header="Header2" key="2"&gt;`} />
            <Space count={8} /> <span className="label">&lt;</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <span className="htmlstr">Content of Panel 2</span>
            <span className="label">&lt;</span>
            <span className="label">/</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <br />
            <Space count={4} /> <Code code={`&lt;/Panel&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Panel header="Header3" key="3"&gt;`} />
            <Space count={8} />
            <span className="label">&lt;</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <span className="htmlstr">Content of Panel 3</span>
            <span className="label">&lt;</span>
            <span className="label">/</span>
            <span className="htmltag">div</span>
            <span className="label">&gt;</span>
            <br />
            <Space count={4} />
            <Code code={`&lt;/Panel&gt;`} />
            <Code code={`&lt;/Collapse&gt;`} />
          </CodeBox>
        </div>
        <section>
          <h2>API</h2>
        </section>
        <section className="sub">
          <h3>Collapse</h3>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>参数</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>activeKey</td>
              <td className="des">当前展开面板 key 的数组</td>
              <td className="type">string[]</td>
              <td>——</td>
            </tr>
            <tr>
              <td>defaultActiveKey</td>
              <td className="des">默认展开面板 key 的数组</td>
              <td className="type">string[]</td>
              <td>——</td>
            </tr>
            <tr>
              <td>accordion</td>
              <td className="des">手风琴模式</td>
              <td className="type">boolean</td>
              <td>false</td>
            </tr>
            <tr>
              <td>showArrow</td>
              <td className="des">是否展示面板头的箭头图标</td>
              <td className="type">boolean</td>
              <td>true</td>
            </tr>
            <tr>
              <td>onChange</td>
              <td className="des">点击面板头导致展开项改变时的回调</td>
              <td className="type">
                (activeKey: string[], e: React.MouseEvent) => any
              </td>
              <td>——</td>
            </tr>
            <tr>
              <td>className</td>
              <td className="des">自定义 Collapse 类名</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>style</td>
              <td className="des">自定义 Collapse 样式</td>
              <td className="type">React.CSSProperties</td>
              <td>——</td>
            </tr>
          </tbody>
        </table>
        <section className="sub">
          <h3>Panel</h3>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>参数</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>header</td>
              <td className="des">面板头内容</td>
              <td className="type">string | React.ReactNode</td>
              <td>——</td>
            </tr>
            <tr>
              <td>disabled</td>
              <td className="des">禁用状态</td>
              <td className="type">boolean</td>
              <td>false</td>
            </tr>
            <tr>
              <td>className</td>
              <td className="des">自定义面板内容区容器类名</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>style</td>
              <td className="des">自定义面板内容区样式</td>
              <td className="type">React.CSSProperties</td>
              <td>——</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default CollapseExample



// WEBPACK FOOTER //
// ./src/examples/Collapse.example.tsx